import { defineStore } from 'pinia'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

export const usePageStore = defineStore('page', () => {
  const route = useRoute()

  const currentPage = computed(() => ({
    title: route.meta.title ?? 'Página não encontrada',
    helpKey: route.meta.helpKey ?? 'default',
    icon: route.meta.icon ?? null
  }))

  return { currentPage }
})
